/*
 * @Author: Vanny
 * @Date: 2019-05-08 14:39:21
 * @LastEditors: Vanny
 * @LastEditTime: 2020-07-06 16:27:35
 * @Description: 财务管理-仓库
 */
import { call, put, select } from 'redux-saga/effects';
import moment from 'moment';
import { pick } from 'lodash';
import { $t } from 'src/tools';
import * as financeApi from '../../services/financeApi';
import { financeFilter, shopFilter } from '../../config/constants';
import { fewDayAgo } from '../../utils/date';
import { exportToExcelFromNet } from '../../utils';
import { isMC } from '../../utils/env';

const initialState = {
  query: {
    type: 'custom',
    sday: moment(fewDayAgo(7)),
    eday: moment(),
  },
  list: [],
  keyword: '',
  pagination: {
    total: 0,
    pageSize: 50,
    current: 1,
  },
  duokeFilter: {
    filters: [],
    radios: [],
  },
  exist: false,
};

export const state = initialState;

export const effects = {
  // 导出单据
  *getExport({ payload }) {
    const { query: q, keyword } = yield select((state) => state.financeState);
    const query = {
      ...q,
      ...payload,
      keyword,
      page: 1,
      page_num: 0,
      out: 'excel',
      async: '0',
    };
    const response = yield call(financeApi.requestGetExcel, query);
    if (response) {
      exportToExcelFromNet(response, $t('finance', 'Finance'));
    }
  },
  *getList(action) {
    const state = yield select((state) => state.financeState);
    const query = {
      ...state.query,
      page_num: state.pagination.pageSize,
      page: state.pagination.current,
    };
    const keyword = {
      keyword: state.keyword,
    };
    const response = state.keyword
      ? yield call(financeApi.requestPaymentList, { ...query, ...keyword })
      : yield call(financeApi.requestPaymentList, query);
    if (response) {
      yield put({
        type: 'finance/setState',
        payload: {
          exist: true,
          list: response.list,
          pagination: { ...state.pagination, total: parseInt(response.list_num) },
        },
      });
    }
  },
};

export const reducers = {
  transformFilter(state, action) {
    const {
      appState: {
        accountList: { admin, sale },
        userInfo: { plugins_info: pluginsInfo = [], payment = [], shop_list: shopList = [], role },
      },
    } = action.payload;
    const staffList = [...Object.values(admin || {}), ...Object.values(sale || {})].reduce(
      (acc, v) => (acc.push(...v.staff_list), acc),
      []
    );

    const paymentSetting = payment.map((v) => ({
      name: v.name,
      value: v.id,
    })).concat([
      isMC() && { name: 'Stripe', value: '-102'},
      isMC() && { name: 'PayPal', value: '-101'},
      { name: 'silver_zero', value: '-3' },
      { name: 'ignore_silver_zero', value: 'all_not_free' },
    ]).filter(i => !!i);
    const tagSetting = pluginsInfo.find((p) => p.plugins_id === '182');
    const filters = (shopList.length <= 1
      ? []
      : [
          {
            ...shopFilter,
            options: shopList.map((v) => ({ name: v.name, value: v.id })),
          },
        ]
    ).concat(financeFilter, [
      {
        name: 'pay_method',
        code: 'payment_id',
        options: paymentSetting
      },
      {
        name: 'account',
        code: 'staff_id',
        options: staffList
          .filter((v) => v.allow_bind === '1' && ['1', '2'].includes(v.group_id))
          .map((v) => ({ name: v.name, value: v.id })),
      },
      {
        name: 'flow_tag',
        code: 'tag',
        options: Object.keys(tagSetting?.setting ?? {})
          .filter((k) => tagSetting.setting[k])
          .map((k) => ({
            name: tagSetting.setting[k],
            value: k,
          })),
      },
    ]);

    const radios = filters.map((f) => f.code);
    state.duokeFilter = { filters, radios };
    return { ...state };
  },
  initQuery(state, action) {
    const originQuery = pick(state.query, ['order', 'page', 'page_num', 'isasc']);
    state.query = originQuery;
    return { ...state };
  },
};
